import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { ko } from "./locales/ko";
import { en } from "./locales/en";
import { vi } from "./locales/vi";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
      vi: { translation: vi },
    },
    fallbackLng: "ko",
    supportedLngs: ["ko", "en", "vi"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
